import VouchersPage from "./VouchersPage";

export default VouchersPage;
